/**
 * User API: GET list, GET one, POST (admin create), PUT, DELETE.
 * Use apiClient so token is sent automatically.
 */

import apiClient from './apiClient';
import { mapUserFromApi } from './authApi';

/** GET /api/users - list all users (admin only) */
export const getUsers = async () => {
  const { data } = await apiClient.get('/api/users');
  return Array.isArray(data) ? data.map(mapUserFromApi) : [];
};

/** GET /api/users/me - get current user profile */
export const getMyProfile = async () => {
  const { data } = await apiClient.get('/api/users/me');
  return mapUserFromApi(data);
};

/** GET /api/users/:id - get one user */
export const getUserById = async (id) => {
  const { data } = await apiClient.get(`/api/users/${id}`);
  return mapUserFromApi(data);
};

/** POST /api/users/admin - create user (admin only) */
export const createUser = async (payload) => {
  const { data } = await apiClient.post('/api/users/admin', {
    first_name: payload.first_name,
    last_name: payload.last_name,
    number: payload.number || '',
    email: payload.email,
    password: payload.password || 'changeme',
  });
  return mapUserFromApi(data.user);
};

/** PUT /api/users/:id - update user (including profile fields) */
export const updateUser = async (id, payload) => {
  const body = {};
  if (payload.first_name !== undefined) body.first_name = payload.first_name;
  if (payload.last_name !== undefined) body.last_name = payload.last_name;
  if (payload.number !== undefined) body.number = payload.number;
  if (payload.email !== undefined) body.email = payload.email;
  if (payload.password !== undefined && payload.password) body.password = payload.password;
  if (payload.pan !== undefined) body.pan = payload.pan;
  if (payload.experience !== undefined) body.experience = payload.experience;
  if (payload.risk !== undefined) body.risk = payload.risk;
  if (payload.broker !== undefined) body.broker = payload.broker;
  if (payload.profile_image !== undefined) body.profile_image = payload.profile_image;
  if (payload.subscription_plan !== undefined) body.subscription_plan = payload.subscription_plan;
  const { data } = await apiClient.put(`/api/users/${id}`, body);
  return mapUserFromApi(data.user);
};

/** DELETE /api/users/:id - delete user (admin only) */
export const deleteUser = async (id) => {
  await apiClient.delete(`/api/users/${id}`);
};
